import messages from './home.json' with { type: 'json' };

export const homeSv: Readonly<typeof messages> = messages;
